"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerModalSection = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const HackerModalSection = ({ title, extraTitleContent, children, containerProps, }) => {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    return (react_2.default.createElement(react_1.Flex, Object.assign({ direction: "column", p: 5, pb: 0 }, containerProps),
        react_2.default.createElement(react_1.Flex, { borderBottomColor: primaryColor, borderBottomWidth: "1px", fontSize: "14px", fontWeight: "semibold" },
            react_2.default.createElement(react_1.Box, { flex: 1 }, title),
            extraTitleContent),
        react_2.default.createElement(react_1.Box, { flex: 1, py: 5, overflowY: ['initial', null, null, 'auto'] }, children)));
};
exports.HackerModalSection = HackerModalSection;
//# sourceMappingURL=HackerModalSection.js.map